// @ts-nocheck
import formReducer, {
    FoundationComponentsFormActions,
} from "@store/Framework/Store/Foundation/Components/Form/FormReducer";
import { combineReducers } from "redux";

const componentsReducers = {
    form: formReducer,
};

export type FoundationComponentsActions = FoundationComponentsFormActions;
export default combineReducers(componentsReducers);
